// extracted by css-extract-rspack-plugin
export default {"paddingTableSummary":"hb_bUqhXol4tagiO","textCenter":"aYk9_9wPM4p37a9c"};